module.exports = __webpack_public_path__ + "img/logo-instagram.48042f8b.png";